export function useWidgetHelpers() {
    const fetchDependenciesHandlingRestartIfRequired = (widgetType, dependencies, refresh = true) => {
        const authHelpers = useAuthHelpers()
        const widgetsStore = useWidgetsStore()

        return widgetsStore.fetchDependencies(widgetType, dependencies, refresh)
            .then((results) => {
                each(results, (result, index) => {
                    if (result.status !== 'rejected' || !result.reason || !authHelpers.isAuthenticationException(result.reason)) {
                        return
                    }
                    authHelpers.handleForceLoginRestartIfRequired(result.reason.response?.data)
                })
                return results
            })
    }

    return {
        fetchDependenciesHandlingRestartIfRequired,
    }
}
